import { render, staticRenderFns } from "./CommitteeListItem.vue?vue&type=template&id=0d4c3e88"
import script from "./CommitteeListItem.vue?vue&type=script&lang=js"
export * from "./CommitteeListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports